// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.b33ecf8e1.chunk.js";
	if (chunkId === 12) return "static/js/profiler.b33ecf8e1.chunk.js";
	if (chunkId === 177) return "static/js/177.b33ecf8e1.chunk.js";
	// return url for filenames based on template
	return undefined;
};